export default __webpack_public_path__ + "97233c7a74622c3e5ad25f06152e80e7.png";